import { requestFrame } from '@shared/utils';
import { reactive, DirectiveBinding } from 'vue';
import ToastLibrary from './ToastLibrary';
import { emittable } from '@shared/utils/emittable';

export const toast: any = emittable<any>({
    sc: 0,
    time: {
        stay: 10000,
        linger: 2000,
        queue: 200,
    },
    timestamp: 0,
    els: {},
    queue: [],
    groups: reactive({
        'top-left': {},
        'top-center': {},
        'bottom-left': {},
        'bottom-center': {},
    }),
    post(data: any) {
        if (!data) return;
        let now = Date.now(),
            elapsed = now - this.timestamp;

        if (now - this.timestamp < this.time.queue) {
            this.queue.push(data);

            setTimeout(
                () => {
                    let i = this.queue.shift();

                    i.sc = ++this.sc;
                    this.groups[i.pos][i.sc] = i;
                },
                this.queue.length * this.time.queue - elapsed
            );
        } else {
            data.sc = ++this.sc;
            this.timestamp = now;
            this.groups[data.pos][this.sc] = data;
        }
    },
});

toast.addToLibrary(ToastLibrary);
toast.addListener('note', toast.post.bind(toast));

let once: boolean = false;

export const vNotify = {
    mounted(el: HTMLElement, { value }: DirectiveBinding) {
        // return

        let { sc, pos, toast } = value,
            rect = el.getBoundingClientRect();

        el.style.height = `${rect.height}px`;
        toast.els[sc] = el;

        const closeNote = (el: HTMLElement) => {
            setTimeout(() => {
                requestFrame(() => {
                    el.style.height = `${0}px`;
                    el.style.margin = `${0}px`;
                    el.style.transform = `translate3d(0,${-rect.height * 2}px,0)`;

                    exit();
                });
            }, toast.time.stay);

            const exit = () => {
                setTimeout(() => {
                    delete toast.groups[pos][sc];
                }, toast.time.linger);
            };
        };
        closeNote(el);
        if (!once) {
            once = true;
            toast.addListener('closenote', closeNote);
        }
    },
};
